import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box, Image, Text, Flex } from 'atoms';

const Day = styled.span`
	color: ${(props) => props.theme.colors.SilverChalice};
	font-size: 12px;
`;

export default function Stats({ src, bg, label, total, alt, fontSize }) {
	return (
		<Flex mb="5px" alignItems="center">
			<Box
				height="30px"
				width="30px"
				mr="5px"
				py="6px"
				borderRadius="20px"
				bg={bg}
				textAlign="center"
			>
				<Image src={src} alt={alt} height={15} width={15} />
			</Box>
			<Flex flexDirection="column" ml="3px">
				<Text fontSize={fontSize} pb="8px">
					{label}
				</Text>
				<Text fontSize="16px">
					{total < 10 ? `0${total}` : total}
					<Day> days</Day>
				</Text>
			</Flex>
		</Flex>
	);
}

Stats.propTypes = {
	src: PropTypes.string,
	bg: PropTypes.string,
	label: PropTypes.string,
	total: PropTypes.array,
	alt: PropTypes.string,
	fontSize: PropTypes.number,
};
